import { render, staticRenderFns } from "./creditsMultiplication.vue?vue&type=template&id=78448ec0"
import script from "./creditsMultiplication.vue?vue&type=script&lang=js"
export * from "./creditsMultiplication.vue?vue&type=script&lang=js"
import style0 from "./creditsMultiplication.vue?vue&type=style&index=0&id=78448ec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports